export const camera_permission_handler = {
    data() {
        return {
            isDisabledUpload: true,
            isListenerAttached: false,
            boundPermissionListener: null, // Store the bound listener
        };
    },
    beforeDestroy() {
        this.removeListener();
    },
    methods: {
        async isHavePermissions() {
            if (window.flutter_inappwebview) {
                try {
                    const status = await navigator.permissions.query({ name: 'camera' });
                    return status.state === 'granted';
                } catch (error) {
                    console.warn('Permission query failed:', error);
                    return false;
                }
            }
            return true;
        },

        async getPermission(event) {
            if (!this.isDisabledUpload) return event;

            const havePermission = await this.isHavePermissions();
            const getVersionFn = window.getWebViewVersion;

            const isAndroidWebView = window.flutter_inappwebview && this.webview === 'android';

            if (!isAndroidWebView || havePermission || typeof getVersionFn !== 'function') {
                this.isDisabledUpload = false;
                setTimeout(() => {
                    this.triggerAvatarUpload('getPermission');
                }, 100);
                return;
            }

            // Handle permission request in Android WebView
            if (isAndroidWebView && !havePermission) {
                this.postFlutterMessage('cameraPermission');

                if (!this.isListenerAttached) {
                    this.isListenerAttached = true;

                    // Bind and store the reference
                    this.boundPermissionListener = this.onCameraPermissionResponse.bind(this);

                    document.addEventListener('cameraPermissionResponse', this.boundPermissionListener);
                }
            }
        },

        onCameraPermissionResponse(event) {
            this.removeListener();

            let data = {};
            try {
                data = JSON.parse(event.data);
            } catch {
                return false;
            }

            if (data?.data?.success) {
                this.isDisabledUpload = false;
                setTimeout(() => {
                    this.triggerAvatarUpload('response');
                }, 200);
            }
        },

        removeListener() {
            if (this.boundPermissionListener) {
                document.removeEventListener('cameraPermissionResponse', this.boundPermissionListener);
                this.isListenerAttached = false;
                this.boundPermissionListener = null;
            }
        },
    },
};
